import React from "react";
import { navigate } from "utilities/navigate";
import { getRoute, routeParam } from "utilities/route";
import { PickSlipNoContest, PickSlipContest } from "./";
import { Clamp } from "components/Clamp";
import { Alert } from "sections/Betting/Betslip/components/Alert";
import { ReactComponent as LockIcon } from "assets/icons/lock-6.svg";
import { ReactComponent as LocationBlock } from "assets/icons/style-two-pin-off-map.svg";
import * as styles from "./PickSlip.module.scss";

export const getUnauthorisedMessageElement = (
  isLoggedIn: boolean,
  permission: string,
): JSX.Element | null => {
  const { message, action, actionText, icon } =
    getUnauthorisedMessage(isLoggedIn, permission) || {};

  if (message) {
    return (
      <Alert
        variant={`danger`}
        icon={icon}
        clamp={
          actionText || action ? (
            <Clamp
              className={styles.clickable}
              onClick={action ?? (() => {})}
              variant={`danger`}
            >
              {actionText ?? "Got It"}
            </Clamp>
          ) : null
        }
      >
        {message}
      </Alert>
    );
  } else {
    return null;
  }
};

type UnauthorisedMessage = {
  message: string | JSX.Element;
  action?: () => void;
  actionText?: string;
  icon?: React.ReactNode;
};

export const getUnauthorisedMessage = (
  isLoggedIn: boolean,
  permission: string,
): UnauthorisedMessage => {
  if (!isLoggedIn) {
    return null;
  }

  let message;
  let action;
  let actionText;
  let icon;

  switch (permission) {
    case "GRANTED":
      return null;
    case "RESIDENTIAL_LOCATION_UNSUPPORTED":
      message = "Pickems coming soon to your region";
      icon = <LocationBlock />;
      break;
    case "PHYSICAL_LOCATION_UNSUPPORTED":
      message = "Pickems coming soon to your region";
      icon = <LocationBlock />;
      break;
    case "VERIFICATION_STATUS_UNSUPPORTED":
      message = "Your account requires verification";
      action = () => navigate("/account/verification/");
      actionText = "Verify";
      break;
    case "ACCOUNT_REOPEN_REQUIRED":
      message = "Your account requires reopening";
      action = () => navigate("/account/reopen/");
      actionText = "Reopen";
      icon = <LockIcon />;
      break;
    default:
      message = "Sorry you are unable to play Pickems at this time";
  }

  return {
    message,
    action,
    actionText,
    icon,
  };
};

const PickSlip = () => {
  const contestParam = routeParam(getRoute(), "contest", null);

  if (contestParam) {
    return <PickSlipContest />;
  } else {
    return <PickSlipNoContest />;
  }
};

export default PickSlip;
